import styled from '@emotion/styled'

export const ProductContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: 10px;

  /* Custom table cell */
  .ReactTable .rt-tbody .rt-td:nth-child(3) {
    justify-content: flex-start;
  }
`
